export const SET_TARGET_KEYS = "SET_TARGET_KEYS";
export const SET_TARGET_KEYS_FREE_CLASS = "SET_TARGET_KEYS_FREE_CLASS";
